'use client';

import { createContext, type ReactNode } from 'react';
import type { FeatureFlagKey } from './flags';

export type FlagValues = Record<FeatureFlagKey, string | boolean>;

export const FeatureFlagsContext = createContext<FlagValues | null>(null);

export function FeatureFlagsProvider({
  initialFlags,
  children,
}: {
  initialFlags: FlagValues;
  children: ReactNode;
}) {
  return (
    <FeatureFlagsContext.Provider value={initialFlags}>{children}</FeatureFlagsContext.Provider>
  );
}
